import { render, staticRenderFns } from "./LoginRegDecision.vue?vue&type=template&id=cef51d56"
import script from "./LoginRegDecision.vue?vue&type=script&lang=js"
export * from "./LoginRegDecision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports